import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  return next(req).pipe(
    catchError((error) => {
      console.log(error);
      if (error.status === 401 || error.status === 403) {
        router.navigate(['/auth/login']);
      }
      return throwError(() => error);
    })
  );
};
